import React from 'react'
import styled from 'styled-components'

export default function About() {
  return (
    <Wrapper id="about">
        <div id="my-image">
                <img src="/Assets/profile.jpg"
                    alt="Profile-pic" />
            </div>
            <p id="about-me-text">
                &emsp;&emsp;&emsp;<strong>Web Developer</strong> with ability to learn and collaborate in rapidly changing environments and compositions. Worked through 1000+ hours learning <mark>HTML, CSS, Javascript, React.Js, Node.Js And Java.</mark> Eager to tackle web development/design challenges to achieve lasting impacts on user experience.
            </p>
            <p id='resume-btn'><a target="_blank" href="Assets/Resume.pdf" ><button className='resume-button'>View Resume</button></a>
            <a href="Assets/Resume.pdf" download="BhushanResume"><button className='resume-button'>Download Resume</button></a></p>
    </Wrapper>
  )
}

const Wrapper=styled.section`
position: relative;
height: auto;
width: 100%;
#my-image {
    position: relative;
    margin: auto;
    width: 12rem;
    height: 12rem;
    margin-top: -17vh;
    z-index: 1;
}

#my-image img {
    border-radius: 50%;
    height: 100%;
    width: 100%;
    border: 4px solid white;
    box-shadow: 0px 0px 15px 1px lightgrey;
    transition: transform .3s ease-in-out, box-shadow .5s;
}

#my-image img:hover {
    box-shadow: 0px 0px 15px 1px var(--section-color);
    transform: scale(1.1);
}

#about-me-text {
    width: 70%;
    margin: auto;
    margin-top: 4rem;
    word-spacing:1rem;
    letter-spacing:.1rem;
    text-align:center;
}
mark{
    background-color: transparent;
    color: yellow;
}
#resume-btn{
    display: flex;
    justify-content:center;
    gap: 1rem;
}
.resume-button{
    width: 10rem;
    height: 3rem;
    border-radius: 1rem;
    background-color: #1d1c21;
    border: 0;
    color: white;
    cursor: pointer;
    transition: all .2s ease-in-out;
    &:hover{
        background-color: transparent;
        border: 1px solid white;
    }
}

@media only screen and (max-width: 750px){
    #my-image{
        
    margin-top: 5vh;
    }
}
`